import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle } from 'lucide-react';

export const VideoSection = () => (
  <section id="video" className="py-20 sm:py-28 bg-forest-100/50" data-testid="video-section">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <div className="max-w-2xl mb-10">
        <p className="font-body-landing text-terracotta font-bold text-sm tracking-[0.15em] uppercase mb-4 flex items-center gap-2">
          <PlayCircle className="w-4 h-4" /> Míralo en acción
        </p>
        <h2 className="font-display font-black text-forest-900 text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
          45 segundos y lo entenderás todo
        </h2>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6 }}
        className="rounded-3xl overflow-hidden border border-forest-900/10 shadow-[0_24px_60px_rgb(15,28,20,0.15)] bg-forest-900"
      >
        <video
          controls
          preload="none"
          poster="/landing/demo_poster.jpg"
          className="w-full block"
          data-testid="demo-video"
        >
          <source src="/landing/demo.mp4" type="video/mp4" />
          Tu navegador no soporta la reproducción de vídeo.
        </video>
      </motion.div>
      <p className="font-body-landing text-sm text-forest-700/70 mt-5 text-center">
        Kiosko con PIN · App móvil con GPS · Panel en tiempo real · Informes para la Inspección
      </p>
    </div>
  </section>
);
